// Why the job could not be shown: a guest account opened a job of the customer's real
// account, a signed-in account has no access to it, or the request itself failed.
export type PastJobLoadError = 'guest-account' | 'no-access' | 'failed';

// HttpClientCustom rejects an API error as { code, message } and other clients pass the
// HttpErrorResponse with its status, so read either; a 403 or 404 means the job
// is not one this account may read, so trying again won't help. Guest accounts (placeholder
// emails) are made from the welcome screen, so theirs is a customer who still has to sign
// in to their own account. The property-manager demo session is the same case.
export function pastJobLoadError(err: any, email: string | null, isDemoSession = false): PastJobLoadError {
  const status = err?.status ?? err?.code;
  if (status !== 403 && status !== 404) {
    return 'failed';
  }
  const isGuest = isDemoSession || (email || '').includes('placeholder.tidy');
  return isGuest ? 'guest-account' : 'no-access';
}
